<template>
  <div>
    <vxe-modal
      :zIndex="12"
      v-model="modalBarang"
      title="Select Items"
      width="80%"
      height="85%"
      show-zoom
      resize
    >
      <template #default>
        <el-button
          class="mb-3"
          v-if="showUpload"
          size="mini"
          type="primary"
          @click="uploadExcel"
          >Upload Excel</el-button
        >
        <br />
        <vxe-radio-group v-model="selectTab" @change="tabChange">
          <vxe-radio-button
            v-if="jenis.includes('all')"
            label="all"
            :content="$t('all').toUpperCase()"
          ></vxe-radio-button>
          <vxe-radio-button
            v-if="jenis.includes('all') || jenis.includes('fg')"
            label="fg"
            :content="$t('fg').toUpperCase()"
          ></vxe-radio-button>
          <vxe-radio-button
            v-if="jenis.includes('all') || jenis.includes('material')"
            label="material"
            :content="$t('materialbtn').toUpperCase()"
          ></vxe-radio-button>
          <vxe-radio-button
            v-if="jenis.includes('all') || jenis.includes('mesin')"
            label="mesin"
            :content="$t('mesin').toUpperCase()"
          ></vxe-radio-button>
          <vxe-radio-button
            v-if="jenis.includes('all') || jenis.includes('scrap')"
            label="scrap"
            :content="$t('Scrap').toUpperCase()"
          ></vxe-radio-button>
          <vxe-radio-button
            v-if="jenis.includes('all') || jenis.includes('bsj')"
            label="bsj"
            :content="$t('setengahJadi').toUpperCase()"
          ></vxe-radio-button>
          <vxe-radio-button
            v-if="jenis.includes('all') || jenis.includes('defect')"
            label="defect"
            :content="$t('defect').toUpperCase()"
          ></vxe-radio-button>

          <vxe-radio-button
            v-if="jenis.includes('all') || jenis.includes('other')"
            label="other"
            :content="$t('otherService').toUpperCase()"
          ></vxe-radio-button>
        </vxe-radio-group>

        <el-alert
          v-if="selectTab == 'fg'"
          title="BOM Sudah di Input & Tersedia"
          style="background-color: #a1ffba; color: black; margin-top: 3px"
        >
        </el-alert>

        <vxe-table
          size="mini"
          :loading="loadingTable"
          empty-text="Empty Data"
          keep-source
          border
          show-overflow
          class="mt-5"
          show-header-overflow
          ref="xTableSelectItem"
          height="600"
          row-key
          highlight-hover-row
          highlight-current-row
          :row-config="{ isCurrent: true, isHover: true, height: 35 }"
          :column-config="{ resizable: true }"
          :data="tableData"
          :mouse-config="{ selected: true }"
          :checkbox-config="{
            highlight: true,
            range: true,
          }"
          :keyboard-config="{
            isArrow: true,
            isDel: true,
            isEnter: true,
            isTab: true,
            isEdit: true,
          }"
          :edit-config="{
            trigger: 'dblclick',
            mode: 'cell',
            showStatus: true,
          }"
          :scroll-y="{ mode: 'wheel' }"
          @filter-change="changeFilter"
          @cell-dblclick="cellDoubleClick"
          :row-style="rowStyle"
        >
          <vxe-column type="seq" fixed="left" width="60" />
          <vxe-column type="SELECT" width="120">
            <template #default="{ row }">
              <el-button
                type="primary"
                @click="sendData(row)"
                icon="el-icon-check"
                size="mini"
                >{{ $t("select") }}</el-button
              >
            </template>
          </vxe-column>
          <template v-for="(d, index) in columns">
            <template v-if="!d.children">
              <vxe-column
                :key="index"
                :width="d.width"
                :field="d.field"
                header-align="center"
                :align="d.align"
                :title="d.title"
                :filters="[{ data: '' }]"
                :filter-method="$$filterHeaderTable"
              >
                <template #filter="{ $panel, column }">
                  <input
                    type="type"
                    v-for="(option, index) in column.filters"
                    :key="index"
                    style="padding: 5px"
                    v-model="option.data"
                    @input="$panel.changeOption($event, !!option.data, option)"
                  />
                </template>
              </vxe-column>
            </template>
            <template v-else>
              <vxe-colgroup
                header-align="center"
                :title="d.title"
                :key="d.field"
              >
                <vxe-column
                  v-for="(ch, chi) in d.children"
                  :key="chi"
                  :field="ch.field"
                  :title="ch.title"
                  :width="ch.width"
                  :align="ch.align"
                  header-align="center"
                  :filters="[{ data: '' }]"
                  :filter-method="$$filterHeaderTable"
                >
                  <template #filter="{ $panel, column }">
                    <input
                      type="type"
                      v-for="(option, index) in column.filters"
                      :key="index"
                      style="padding: 5px"
                      v-model="option.data"
                      @input="
                        $panel.changeOption($event, !!option.data, option)
                      "
                    />
                  </template>
                </vxe-column>
              </vxe-colgroup>
            </template>
          </template>
        </vxe-table>
        <vxe-form title-align="right" title-width="60">
          <vxe-form-item align="center" span="24">
            <template #default>
              <vxe-button type="reset" @click="modalBarang = false">{{
                $t("close")
              }}</vxe-button>
            </template>
          </vxe-form-item>
          <vxe-form-item align="center" span="24">
            <template #default>
              <el-descriptions
                border
                v-if="clickedItem"
                title="Selected Items"
                :labelStyle="labelStyle()"
              >
                <el-descriptions-item label="Item Code">{{
                  clickedItem.kodeBarang
                }}</el-descriptions-item>
                <el-descriptions-item label="Description">{{
                  clickedItem.namaBarang
                }}</el-descriptions-item>
                <el-descriptions-item label="Stock">
                  <p style="font-weight: 1000; font-size: 15px; color: #3bb6e3">
                    {{ $formatAmountBc(clickedItem.stok) }}
                  </p>
                </el-descriptions-item>
              </el-descriptions>
            </template>
          </vxe-form-item>
        </vxe-form>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
export default {
  props: ["jenis", "showUpload"],

  data() {
    return {
      selectTab: "material",
      loadingTable: false,
      modalBarang: false,
      tableData: [],
      columnAll: [
        {
          field: "jenisBc",
          key: "jenisBc",
          title: "BC CATEGORY",
          width: 200,
          align: "left",
        },
        {
          field: "kodeBarang",
          key: "kodeBarang",
          title: " ITEM CODE",
          width: 200,
          align: "left",
        },
        {
          field: "namaBarang",
          key: "namaBarang",
          title: " ITEM NAME",
          width: 200,
          align: "left",
        },
        {
          field: "style",
          key: "style",
          title: this.$store.state.styleName,
          show: this.$store.state.availableStyle,
          width: 150,
          align: "center",
        },
        {
          field: "color",
          key: "color",
          title: this.$store.state.colorName,
          show: this.$store.state.availableColor,

          width: 150,
          align: "center",
        },
        {
          field: "size",
          key: "size",
          title: this.$store.state.sizeName,

          width: 150,
          align: "center",
          show: this.$store.state.availableSize,
        },
        {
          field: "spec",
          key: "spec",
          title: this.$store.state.specName,

          width: 150,
          align: "center",
          show: this.$store.state.availableSpec,
        },

        {
          field: "satuan",
          key: "satuan",
          title: "UOM",
          width: 200,
          align: "center",
        },
      ],
      columnMaterial: [
        {
          field: "kodeBarang",
          key: "kodeBarang",
          title: " ITEM CODE",
          width: 200,
          align: "left",
        },
        {
          field: "namaBarang",
          key: "namaBarang",
          title: " ITEM NAME",
          width: 200,
          align: "left",
        },
        {
          field: "style",
          key: "style",
          title: this.$store.state.styleName,
          show: this.$store.state.availableStyle,
          width: 150,
          align: "center",
        },
        {
          field: "color",
          key: "color",
          title: this.$store.state.colorName,
          show: this.$store.state.availableColor,

          width: 150,
          align: "center",
        },
        {
          field: "size",
          key: "size",
          title: this.$store.state.sizeName,

          width: 150,
          align: "center",
          show: this.$store.state.availableSize,
        },
        {
          field: "spec",
          key: "spec",
          title: this.$store.state.specName,

          width: 150,
          align: "center",
          show: this.$store.state.availableSpec,
        },

        {
          field: "satuan",
          key: "satuan",
          title: "UOM",
          width: 200,
          align: "center",
        },
      ],

      columnsLain: [
        {
          field: "kodeBarang",
          key: "kodeBarang",
          title: " ITEM CODE",
          width: 200,
          align: "left",
        },

        {
          field: "namaBarang",
          key: "namaBarang",
          title: "DESCRIPTION",
          align: "left",
          width: 200,
        },
        {
          field: "spec",
          key: "spec",
          title: this.$store.state.specName,
          show: this.$store.state.availableSpec,
          align: "left",
          width: 200,
        },

        {
          field: "satuan",
          key: "satuan",
          title: "UNIT",
          align: "center",
          width: 100,
        },
      ],
      columnsFG: [
        {
          field: "kodeBarang",
          key: "kodeBarang",
          title: " ITEM CODE",
          width: 200,
          align: "left",
        },

        {
          field: "namaBarang",
          key: "namaBarang",
          title: "ITEM NAME",
          align: "left",
          width: 200,
        },
        {
          field: "style",
          key: "style",
          title: this.$store.state.styleName,
          show: this.$store.state.availableStyle,

          width: 150,
          align: "center",
        },
        {
          field: "color",
          key: "color",
          title: this.$store.state.colorName,
          show: this.$store.state.availableColor,

          width: 150,
          align: "center",
        },
        {
          field: "size",
          key: "size",
          title: this.$store.state.sizeName,
          show: this.$store.state.availableSize,

          width: 150,
          align: "center",
        },
        {
          field: "spec",
          key: "spec",
          title: this.$store.state.specName,
          width: 150,
          align: "center",
          show: this.$store.state.availableSpec,
        },

        {
          field: "satuan",
          key: "satuan",
          title: "UOM",
          align: "center",
          width: 100,
        },
      ],
      columnsBsj: [
        {
          field: "kodeBarang",
          key: "kodeBarang",
          title: " ITEM CODE",
          width: 200,
          align: "left",
        },

        {
          field: "namaBarang",
          key: "namaBarang",
          title: "ITEM NAME",
          align: "left",
          width: 200,
        },

        {
          field: "style",
          key: "style",
          title: this.$store.state.styleName,

          width: 150,
          align: "center",
          show: this.$store.state.availableStyle,
        },
        {
          field: "color",
          key: "color",
          title: this.$store.state.colorName,
          show: this.$store.state.availableColor,

          width: 150,
          align: "center",
        },
        {
          field: "size",
          key: "size",
          title: this.$store.state.sizeName,
          show: this.$store.state.availableSize,

          width: 150,
          align: "center",
        },
        {
          field: "spec",
          key: "spec",
          title: this.$store.state.specName,

          width: 150,
          align: "center",
          show: this.$store.state.availableSpec,
        },

        {
          field: "satuan",
          key: "satuan",
          title: "UOM",
          align: "center",
          width: 100,
        },
      ],
      columnsScrap: [
        {
          field: "kodeBarang",
          key: "kodeBarang",
          title: " ITEM CODE",
          width: 200,
          align: "left",
        },

        {
          field: "namaBarang",
          key: "namaBarang",
          title: "ITEM NAME",
          align: "left",
          width: 200,
        },

        {
          field: "satuan",
          key: "satuan",
          title: "UOM",
          align: "center",
          width: 100,
        },
      ],
      columns: [],
      jenisBc: "",
      clickedItem: null,
    };
  },

  methods: {
    uploadExcel() {
      this.$emit("uploadExcelClick");
    },
    rowStyle({ row }) {
      if (row.idKomposisiHeader) {
        return {
          backgroundColor: "#a1ffba",
          color: "black",
        };
      }
    },
    labelStyle() {
      return {
        fontWeight: "1000",
      };
    },
    async cellDoubleClick({ row }) {
      if (this.clickedItem && this.clickedItem.id == row.id) {
        return;
      }
      row.stok = 0;
      let get = await this.$api.get("api/v1/stok/getbykodebarang", {
        params: {
          kodeBarang: row.kodeBarang,
        },
      });

      // let get = await this.$api.get("api/v1/stok/getnewstok", {
      //   params: {
      //     kodeBarang: row.kodeBarang,
      //   },
      // });
      row.stok = get.data.content;
      this.clickedItem = row;
    },
    async changeFilter({
      column,
      property,
      values,
      datas,
      filterList,
      $event,
    }) {
      if (filterList.length == 0) {
        this.tabChange();
        return;
      }

      this.searchData(filterList);
    },
    async searchData(filterList) {
      let dataSearch = {};
      for (let elm of filterList) {
        dataSearch[elm.field] = elm.datas[0];
      }

      if (this.selectTab != "all") {
        dataSearch.jenisBc = this.jenisBc;
      }
      dataSearch.companyCode = this.$store.state.companyCode;
      let get = await this.$api.get(this.$serviceApi + "service/barang", {
        params: dataSearch,
      });
      this.tableData = get.data;
    },
    tabChange() {
      let tbl = this.$refs["xTableSelectItem"];
      if (tbl) {
        this.$refs["xTableSelectItem"].clearFilter();
      }
      if (this.selectTab == "material") {
        this.columns = this.columnMaterial;
        this.getData("MATERIAL");
      } else if (this.selectTab == "scrap") {
        this.columns = this.columnsScrap;
        this.getData("SCRAP");
      } else if (this.selectTab == "mesin") {
        this.columns = this.columnsScrap;
        this.getData("MESIN");
      } else if (this.selectTab == "fg") {
        this.columns = this.columnsFG;
        this.getData("BARANG JADI");
      } else if (this.selectTab == "all") {
        this.columns = this.columnAll;
        this.getData("BARANG JADI");
      } else if (this.selectTab == "bsj") {
        this.columns = this.columnsBsj;
        this.getData("BARANG SETENGAH JADI");
      } else if (this.selectTab == "defect") {
        this.columns = this.columnsBsj;
        this.getData("DEFECT");
      } else if (this.selectTab == "other") {
        this.columns = this.columnsLain;
        this.getData("LAINNYA");
      }

      let col = [];
      setTimeout(() => {
        this.columns.forEach((m) => {
          if (" STYLE , COLOR , SIZE , SPEC ".includes(String(m.title))) {
            if (this.$store.state.columnTransaction.includes(m.title)) {
              col.push(m);
            }
          } else {
            col.push(m);
          }
        });
        this.columns = col;
      }, 2500);
    },
    async getData(data) {
      this.columns = this.columns.filter(
        (f) => f.show != false || f.show == undefined || f.show == null
      );
      this.loadingTable = true;
      this.jenisBc = data;
      const response = await this.$api.get(
        `api/v1/masterdata/barang/page/findbyjenisbc`,
        {
          params: {
            page: 0,
            search: "",

            pagelimit: 500,
            jenisBc: data,
          },
        }
      );

      this.tableData = response.data.content;
      this.loadingTable = false;
    },
    openModal() {
      if (this.jenis) {
        if (typeof this.jenis == "string") {
          this.selectTab = this.jenis;
        } else {
          this.selectTab = this.jenis[0];
        }
        console.log(this.selectTab);
        this.tabChange();
      }
      this.modalBarang = true;
    },
    closeModal() {
      this.modalBarang = false;
    },
    async getBarang(jenis) {
      console.log(jenis);
    },
    sendData(row) {
      this.$emit("sendData", row);
    },
  },
  mounted() {
    if (!this.jenis) this.jenis = ["all"];
    if (this.jenis && this.jenis.includes("all")) {
      this.selectTab = "all";
    } else if (this.jenis && !this.jenis.includes("all")) {
      if (typeof this.jenis == "string") this.selectTab = this.jenis;
      if (typeof this.jenis != "string") this.selectTab = this.jenis[0];
    }

    this.tabChange();
  },
};
</script>
<style></style>
